// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1fQOh","content":"Consent_content__3rZ1R","footer":"Consent_footer__3XMQR"};